<template>
	<div class="small-page">
		<HeaderAuth :showSignIn="showSignIn" />
		<main>
			<b-modal hide-footer v-model="showSignUp" class="signUp">
				<SignUp v-on:login="openSignIn" />
			</b-modal>
			<div class="container main">
				<div class="title">
					<h4 class="text-accent">Indigo mental club</h4>
					<h4>{{ 'INTERNATIONAL SCHOOL' | translate }}</h4>
					<h1 class="text-main">{{ 'Mental Arithmetic' | translate }}</h1>
					<p>{{ 'For children aged 5-14.' | translate }}</p>
					<button @click="openSignUp" v-if="($i18n.locale() === 'ua' || $i18n.locale() === 'ru') && !isUS"
						class="btn btn-cabinet btn-register">
						<svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<g clip-path="url(#clip0)">
								<path
									d="M11.829 11.5609C13.4172 11.5609 14.7925 10.9913 15.9163 9.86737C17.04 8.74365 17.6096 7.36871 17.6096 5.78027C17.6096 4.19238 17.04 2.81726 15.9161 1.69318C14.7922 0.569641 13.4171 0 11.829 0C10.2405 0 8.8656 0.569641 7.74188 1.69336C6.61816 2.81708 6.04834 4.1922 6.04834 5.78027C6.04834 7.36871 6.61816 8.74384 7.74207 9.86755C8.86597 10.9911 10.2411 11.5609 11.829 11.5609Z"
									fill="white"></path>
								<path
									d="M21.9435 18.4547C21.9111 17.987 21.8456 17.4769 21.7491 16.9382C21.6517 16.3954 21.5262 15.8824 21.3761 15.4135C21.221 14.9288 21.0101 14.4501 20.7493 13.9915C20.4787 13.5154 20.1608 13.1008 19.8041 12.7597C19.4312 12.4028 18.9745 12.1159 18.4464 11.9066C17.9202 11.6984 17.337 11.593 16.7131 11.593C16.4681 11.593 16.2312 11.6935 15.7736 11.9914C15.492 12.175 15.1626 12.3875 14.7949 12.6224C14.4805 12.8227 14.0546 13.0104 13.5286 13.1803C13.0153 13.3464 12.4942 13.4306 11.9799 13.4306C11.4655 13.4306 10.9446 13.3464 10.4308 13.1803C9.90527 13.0106 9.47937 12.8229 9.16534 12.6226C8.80115 12.3898 8.47156 12.1774 8.18573 11.9912C7.7287 11.6933 7.49158 11.5928 7.24658 11.5928C6.62256 11.5928 6.03955 11.6984 5.51349 11.9068C4.98578 12.1157 4.52893 12.4026 4.15558 12.7599C3.79907 13.1012 3.48102 13.5156 3.21075 13.9915C2.9502 14.4501 2.73926 14.9286 2.58398 15.4136C2.43402 15.8826 2.30859 16.3954 2.21118 16.9382C2.11469 17.4761 2.04913 17.9865 2.01672 18.4552C1.98486 18.9144 1.96875 19.3911 1.96875 19.8724C1.96875 21.1252 2.367 22.1395 3.15234 22.8875C3.92798 23.6256 4.95428 24 6.20233 24H17.7585C19.0065 24 20.0325 23.6257 20.8083 22.8875C21.5938 22.14 21.9921 21.1256 21.9921 19.8723C21.9919 19.3887 21.9756 18.9117 21.9435 18.4547Z"
									fill="white"></path>
							</g>
						</svg>
						<span class="dashboard-btn">{{ 'Registration' | translate }}</span>
					</button>
					<b-button v-else to="/demo" size="lg" variant="primary" class="btn-white" @click="showLanguageModal = true">
						{{ 'demo.title' | translate }}
					</b-button>
				</div>
				<RegistrationTrialLes />
			</div>
		</main>
		<footer>
			<div class="container footer">
				<div class="footer-left">
					<div class="soc-icons mr-5">
						<a class="mr-3" href="https://www.facebook.com/indigo.mental/" target="_blank">
							<i class="fa-brands fa-facebook-f" aria-hidden="true" />
						</a>
						<a class="mr-3" href="https://www.youtube.com/channel/UClJPwZ5I1maMn-VJQHJdGQw" target="_blank">
							<i class="fa-brands fa-youtube" aria-hidden="true"></i>
						</a>
						<a href="https://instagram.com/indigo_mental_official?igshid=bza2g349yekm" target="_blank">
							<i class="fa-brands fa-instagram" aria-hidden="true" />
						</a>
					</div>

					<a class="button-contract" href="https://indigomental.com/public_contract">
						<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M10.155 12.1267C9.64082 12.1267 9.34082 12.6158 9.34082 13.2708C9.34082 13.93 9.64999 14.3958 10.16 14.3958C10.6742 14.3958 10.9692 13.9058 10.9692 13.2508C10.9692 12.6458 10.6792 12.1267 10.155 12.1267Z"
								fill="#F8F8F8" />
							<path
								d="M11.6666 1.66667H4.99992C4.55789 1.66667 4.13397 1.84227 3.82141 2.15483C3.50885 2.46739 3.33325 2.89131 3.33325 3.33334V16.6667C3.33325 17.1087 3.50885 17.5326 3.82141 17.8452C4.13397 18.1577 4.55789 18.3333 4.99992 18.3333H14.9999C15.4419 18.3333 15.8659 18.1577 16.1784 17.8452C16.491 17.5326 16.6666 17.1087 16.6666 16.6667V6.66667L11.6666 1.66667ZM7.62908 14.545C7.27408 14.84 6.73492 14.9792 6.07575 14.9792C5.67992 14.9792 5.40075 14.9542 5.21075 14.9292V11.62C5.55156 11.5709 5.89561 11.5478 6.23992 11.5508C6.87992 11.5508 7.29492 11.6658 7.61908 11.9108C7.96908 12.1708 8.18908 12.5858 8.18908 13.1792C8.18908 13.825 7.95408 14.27 7.62908 14.545ZM10.1208 15C9.12075 15 8.53659 14.245 8.53659 13.285C8.53659 12.2758 9.18075 11.5217 10.1758 11.5217C11.2099 11.5217 11.7749 12.2958 11.7749 13.2258C11.7741 14.33 11.1041 15 10.1208 15ZM13.9999 14.365C14.2291 14.365 14.4841 14.3142 14.6349 14.255L14.7499 14.8492C14.6099 14.9192 14.2949 14.9942 13.8858 14.9942C12.7216 14.9942 12.1216 14.27 12.1216 13.31C12.1216 12.1608 12.9408 11.5217 13.9608 11.5217C14.3558 11.5217 14.6549 11.6017 14.7899 11.6717L14.6349 12.2767C14.432 12.1928 14.2144 12.1503 13.9949 12.1517C13.3899 12.1517 12.9199 12.5167 12.9199 13.2667C12.9199 13.9408 13.3199 14.365 13.9999 14.365ZM11.6666 7.50001H10.8333V3.33334L14.9999 7.50001H11.6666Z"
								fill="#F8F8F8" />
							<path
								d="M6.32 12.1358C6.15083 12.1358 6.04083 12.1508 5.97583 12.1658V14.37C6.04083 14.385 6.14583 14.385 6.24 14.385C6.93 14.39 7.37916 14.0108 7.37916 13.2058C7.38416 12.5058 6.975 12.1358 6.32 12.1358Z"
								fill="#F8F8F8" />
						</svg>

						<span class="ml-1">{{ 'Open offer agreement' | translate }}</span>
					</a>
					<!--					<router-link to="/franchise" class="button-text-pink ml-5">-->
					<!--						{{ 'Become franchise' | translate }}-->
					<!--					</router-link>-->
					<a href="https://forms.gle/hLDuk9E2HnrXmXFC6" class="button-text-pink ml-5">
						{{ 'Become franchise' | translate }}
					</a>
				</div>
				<span>Indigo Mental © 2016-{{ currentYear }}</span>
			</div>
		</footer>
	</div>
</template>

<script>
import HeaderAuth from './HeaderAuth'
import RegistrationTrialLes from './RegistrationTrialLes'
import SignUp from './SignUp'

export default {
	name: 'UserAuthWrapper',
	data: () => ({
		showLanguageModal: false,
		showSignUp: false,
		showSignIn: false,

		// isUS: window.location.origin == 'https://us.indigomental.com',
	}),
	components: {
		SignUp,
		HeaderAuth,
		RegistrationTrialLes,
	},
	methods: {
		openSignIn() {
			// console.log(window.location.origin, this.isUS)

			this.showSignIn = true
		},
		closeSignIn() {
			// console.log(window.location.origin, this.isUS)

			this.showSignIn = false
		},
		openSignUp() {
			// console.log(window.location.origin, this.isUS)

			this.showSignUp = true
		},
	},
	mounted() {
		console.log('==========')

		console.log(window.location.origin)

		console.log('-----')

		console.log('isDEV:', this.isDEV)
		console.log('isUS:', this.isUS)
		console.log('isPL:', this.isPL)

		console.log('==========')
	},
	computed: {
		isDEV() {
			return window.location.origin.includes('dev.indigo')
		},

		isUS() {
			return window.location.origin.includes('us.indigo')
		},

		isPL() {
			return window.location.origin.includes('pl.indigo')
		},

		currentYear() {
			return new Date().getFullYear()
		}
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$blue: #646bc0;
$accent: #f9ff00;

.btn-cabinet {
	color: #fff;
	display: flex;
	align-items: center;
	padding: 6px 17px;
	transform: scale(1);
	transition: 0.35s ease-in-out;
	border-radius: 100px;

	span {
		margin-top: 5px;
		margin-left: 5px;
	}

	&:hover {
		color: #fff;
		transform: scale(1.05);
	}
}

.btn-register {
	background: #03ce03 !important;
	margin-right: 20px;
	padding: 0.5rem 1rem;
	font-size: 1.25rem;
}

.form {
	background: #fff;
	box-shadow: 0px 7.04161px 15.3294px rgba(67, 67, 67, 0.0752215),
		0px 4.92415px 6.3357px rgba(67, 67, 67, 0.0444555),
		0px 2.89319px 3.08708px rgba(67, 67, 67, 0.0185339),
		0px 1.21701px 1.54994px rgba(67, 67, 67, 0.00421641);
	border-radius: 16px;
	padding: 28px 38px;
}

.button-contract {
	background: transparent;
	outline: none;
	border: none;
	color: #fff;
}

.button-text-pink {
	background: transparent;
	border: none;
	outline: none;
	color: #e25281 !important;
	text-decoration: underline;
	text-decoration-color: #e25281;
	text-underline-offset: 6px;
	line-height: 24px;

	@media (max-width: 768px) {
		margin-left: 0 !important;
		margin-bottom: 10px;
	}
}

.text-accent {
	color: $accent;
}

.main {
	display: flex;
	justify-content: stretch;
	width: 100%;

	@media (max-width: 992px) {
		flex-direction: column;
		padding: 50px 20px;
	}
}

.title {
	color: white;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	flex: 1;

	@media (max-width: 992px) {
		margin-bottom: 40px;
	}

	h1,
	h4 {
		text-transform: uppercase;
		text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
		margin-left: 0 !important;
	}

	h1 {
		font-size: 56px;
	}
}

.btn-white {
	background: white !important;
	border-radius: 20px;
	color: $blue !important;
	margin-top: 15px;
}

.text-main {
	text-align: left;
	width: min-content;
	margin-left: 0;
	position: relative;
	margin-bottom: 20px;
	padding-bottom: 20px;

	&:after {
		content: '';
		position: absolute;
		bottom: 0;
		height: 3px;
		width: 40px;
		background-color: white;
		left: 0;
	}
}

.footer {
	display: flex;
	align-items: center;
	justify-content: space-between;
	color: #fff;

	@media (max-width: 768px) {
		flex-direction: column;
	}

	&-left {
		display: flex;
		align-items: center;

		@media (max-width: 768px) {
			flex-direction: column-reverse;
		}
	}
}

.soc-icons {
	font-size: 23px;
	width: 170px;
	text-align: center;
	position: relative;
	z-index: 2;

	@media (max-width: 768px) {
		margin-right: 0 !important;
		margin-top: 20px;
	}

	&:after {
		content: '';
		position: absolute;
		left: 0;
		right: 0;
		top: -40px;
		background: #646bc0;
		display: block;
		z-index: 1;
		border-radius: 10em;
		width: 170px;
		height: 170px;

		@media (max-width: 768px) {
			display: none;
		}
	}
}

footer {
	padding: 20px 0 10px;
	text-align: left;

	.col {
		min-width: unset;
	}

	a:not(.btn),
	u {
		position: relative;
		z-index: 11;
		color: #fff;

		&:hover {
			color: $accent;
		}
	}
}

.footer_main {
	border-right: 1px solid #e6e9f3;

	nav a {
		text-decoration: underline;
		display: block;
		margin-bottom: 4px;
		white-space: nowrap;
		width: fit-content;
	}

	@media (max-width: 991px) {
		border-right: none;
		border-top: 1px solid #e6e9f3;
		padding-top: 16px;
		margin-top: 16px;
	}
}

.footer_info {
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	align-self: flex-start;

	>* {
		display: inline-block;
		white-space: nowrap;
		vertical-align: middle;
	}

	p {
		margin: 0 15px;
		white-space: nowrap;
	}

	@media (max-width: 480px) {
		flex-wrap: wrap;
	}
}

.small-page {
	position: relative;
	min-height: 100vh;
	text-align: center;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	justify-content: space-between;
	align-content: stretch;
	//background-image: url(../../assets/bg_landing.png);
}

.btn-primary {
	background-color: #e69c50;
}

.btn-language {
	color: #fff;
	font-size: 20px;
	position: absolute;
	top: 16px;
	right: 16px;

	&:hover {
		color: #e69c50;
	}
}

.small-page {
	background: linear-gradient(-45deg, #82a2d8, #bb9ee1, #82a2d8, #bb9ee1);
	min-height: 100vh;
	background-size: 400% 400%;

	position: relative;
	animation: gradient 15s ease infinite;
}

@keyframes gradient {
	0% {
		background-position: 0% 50%;
	}

	50% {
		background-position: 100% 50%;
	}

	100% {
		background-position: 0% 50%;
	}
}
</style>
